import { MenuItem } from 'primeng/api';

import { CongregacionFiltro } from '../enums/congregacion-filtro.enum';
import { PersonTableRow } from '../interfaces/person-table.interface';

export type PersonTableMenuAction =
  | 'reiniciarFaltas'
  | 'yoContacto'
  | 'aMiCelula'
  | 'dejarDeContactar'
  | 'estudioTerminado'
  | 'cancelarEstudio'
  | 'bautismoRealizado'
  | 'cancelarBautismo'
  | 'abrirChat'
  | 'verPerfil'
  | 'editar'
  | 'eliminar'
  | 'restaurar'
  | 'eliminarSistema';

export interface BuildPersonTableMenuOptions {
  filtro: CongregacionFiltro | string;
  row: PersonTableRow;
  /** Id del usuario en sesion (para acciones de Muelle). */
  yoId?: string | null;
  /** Solo admin ve Reiniciar faltas. */
  isAdmin?: boolean;
  onAction: (action: PersonTableMenuAction, row: PersonTableRow) => void;
}

/** Orden y visibilidad de opciones Congregacion (mayorap2). */
export function buildPersonTableMenuItems(
  options: BuildPersonTableMenuOptions,
): MenuItem[] {
  const { filtro, row, isAdmin = false, onAction } = options;

  if (filtro === 'papelera') {
    return [
      { label: 'Restaurar persona', command: () => onAction('restaurar', row) },
      { label: 'Eliminar del sistema', command: () => onAction('eliminarSistema', row) },
    ];
  }

  const items: MenuItem[] = [];
  const add = (label: string, action: PersonTableMenuAction): void => {
    items.push({
      label,
      command: () => onAction(action, row),
    });
  };

  if (isAdmin && filtro === CongregacionFiltro.Faltas && (row.faltas ?? 0) > 1) {
    add('Reiniciar faltas', 'reiniciarFaltas');
  }

  if (filtro === CongregacionFiltro.Estudiantes) {
    if (row.estudiando) {
      add('Estudio terminado', 'estudioTerminado');
      add('Cancelar estudio', 'cancelarEstudio');
    }
    if (row.inscBautismo) {
      add('Bautismo realizado', 'bautismoRealizado');
      add('Cancelar bautismo', 'cancelarBautismo');
    }
  }

  add('Abrir chat', 'abrirChat');
  add('Ver perfil', 'verPerfil');
  add('Editar', 'editar');
  add('Eliminar', 'eliminar');

  return items;
}

/** Menu de la pantalla /muelle: contacto, celula y eliminar. Sin chat, perfil ni editar. */
export function buildMuelleMenuItems(
  options: Omit<BuildPersonTableMenuOptions, 'filtro' | 'isAdmin'> & { isLider?: boolean },
): MenuItem[] {
  const { row, yoId, isLider = false, onAction } = options;
  const items: MenuItem[] = [];
  const add = (label: string, action: PersonTableMenuAction): void => {
    items.push({
      label,
      command: () => onAction(action, row),
    });
  };

  const contactado = row.contactadoId ?? 'nadie';
  if (contactado === 'nadie') {
    add('Yo lo contacto', 'yoContacto');
  }
  if (yoId && contactado === yoId) {
    if (isLider) {
      add('Agregar a mi célula', 'aMiCelula');
    }
    add('Cancelar contacto', 'dejarDeContactar');
  }
  add('Eliminar', 'eliminar');

  return items;
}
